export const isAbsoluteUrl = url => /^https?:\/\//.test(url);
